// Lib
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

// Selectors
import { isPublishPreviewModeEnabledSelector } from '../preview/previewSelector';
import { getCurrentBoardHasPasswordProtectedError } from '../../element/board/boardPasswordProtectedSelector';

// Components
import BoardPasswordProtectedForm from './BoardPasswordProtectedForm';
import BoardPreviewPasswordProtectedContainer from './BoardPreviewPasswordProtectedContainer';

const mapStateToProps = createStructuredSelector({
    currentBoardHasPasswordProtectedError: getCurrentBoardHasPasswordProtectedError,
    isPreview: isPublishPreviewModeEnabledSelector,
});

const BoardPasswordProtectedContainer = (props) => {
    const { currentBoardHasPasswordProtectedError, isPreview } = props;

    if (isPreview) return <BoardPreviewPasswordProtectedContainer {...props} />;

    if (currentBoardHasPasswordProtectedError) return <BoardPasswordProtectedForm />;

    return React.Children.only(props.children);
};

BoardPasswordProtectedContainer.propTypes = {
    children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
    currentBoardHasPasswordProtectedError: PropTypes.bool,
    isPreview: PropTypes.bool,
};

export default connect(mapStateToProps)(BoardPasswordProtectedContainer);
